<form nz-form style="padding-top:12px;padding-right:12px"   autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Cơ sở</nz-form-label>
        <asc-autocomplete [ascModel]="SchoolControl" (ascModelChange)="changeSchool($event)"
          [placeholder]="'Chọn cơ sở'" [getListAC]="getSchoolACFn"></asc-autocomplete>
      </nz-form-item>
    </div>

 

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Năm</nz-form-label>
        <asc-autocomplete [ascModel]="CourseControl" (ascModelChange)="changeCourse($event)"
          [placeholder]="'Chọn năm'" [getListAC]="getCourseACFn"></asc-autocomplete>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Giáo viên chủ nhiệm</nz-form-label>
        <asc-autocomplete [ascModel]="GiaoVienChuNhiemControl" (ascModelChange)="changeGiaoVienChuNhiem($event)"
          [placeholder]="'Chọn giáo viên chủ nhiệm'" [getListAC]="getGiaoVienChuNhiemACFn"></asc-autocomplete>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24"   nzRequired nzFor="className" #label>Tên lớp</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!" [nzValidateStatus]="lophocnienhoc.className ? '' : 'error'">
          <input nz-input [(ngModel)]="lophocnienhoc.className" [ngModelOptions]="{standalone: true}" type="text"
            placeholder="Nhập tên lớp" [jAutofocus]>
        </nz-form-control>
      </nz-form-item>
    </div>

   
    
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu &
        Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>